export var DataMapType;
(function(DataMapType2) {
  DataMapType2["dateStringFormat"] = "dateStringFormat";
  DataMapType2["urlStringToObject"] = "urlStringToObject";
})(DataMapType || (DataMapType = {}));
